// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e5a70eaa","667":"8907eb10"}[chunkId] + ".chunk.js";
};